import packageJson from '../../package.json';

const asBool = (value?: string): boolean => value === 'true';

export interface ConfigState {
    backend: {
        MAP_SERVICE_API_KEY?: string;
        BACKEND_DOMAIN?: string;
        MAP_SERVICE?: string;
        POI_SERVICE?: string;
        GEOFENCE_SERVICE?: string;
        MARKETPLACE_SERVICE?: string;
        MARKETPLACE_UPSELLING_SERVICE?: string;
        MARKETPLACE_BUY_BUTTON_SERVICE?: string;
    };
    login: {
        authority?: string;
        clientId?: string;
        oauthScope: string[];
        mockAuthorization: boolean;
        preventRedirect: boolean;
        redirectUri?: string;
        silentRedirectUri?: string;
        defaultLocale: string;
    };
    datadog: {
        datadog_logs_client_token: string;
        datadog_rum_app_id: string;
        datadog_rum_client_token: string;
    };
    id?: string;
    client_id?: string;
    aws_client_id?: string;
    build_version?: string;
    app_version?: string;
    serviceName: string;
    serviceVersion: string;
    serviceEnvironment: string;
    enableMockServer: boolean;
    logoutUri?: string;
    CHARGING_STATION_WIDGET_ORIGIN?: string;
}

export const config: ConfigState = {
    backend: {
        MAP_SERVICE_API_KEY: import.meta.env.VITE_MAP_SERVICE_API_KEY,
        BACKEND_DOMAIN: import.meta.env.VITE_BACKEND_DOMAIN,
        MAP_SERVICE: import.meta.env.VITE_MAP_SERVICE,
        POI_SERVICE: import.meta.env.VITE_POI_SERVICE,
        GEOFENCE_SERVICE: import.meta.env.VITE_GEOFENCE_SERVICE,
        MARKETPLACE_SERVICE: import.meta.env.VITE_RIO_MARKETPLACE_SERVICE,
        MARKETPLACE_UPSELLING_SERVICE: import.meta.env.VITE_RIO_MARKETPLACE_UPSELLING_SERVICE,
        MARKETPLACE_BUY_BUTTON_SERVICE: import.meta.env.VITE_RIO_MARKETPLACE_BUY_BUTTON_SERVICE,
    },
    login: {
        authority: import.meta.env.VITE_LOGIN_AUTHORITY,
        clientId: import.meta.env.VITE_CLIENT_ID,
        oauthScope: import.meta.env.VITE_AUTH_SCOPES,
        mockAuthorization: asBool(import.meta.env.VITE_LOGIN_MOCK_AUTHORIZATION),
        preventRedirect: asBool(import.meta.env.VITE_LOGIN_PREVENT_REDIRECT),
        redirectUri: import.meta.env.VITE_LOGIN_REDIRECT_URI,
        silentRedirectUri: import.meta.env.VITE_LOGIN_SILENT_REDIRECT_URI,
        defaultLocale: import.meta.env.VITE_DEFAULT_LOCALE,
    },
    datadog: {
        datadog_logs_client_token: import.meta.env.VITE_DATADOG_LOGS_CLIENT_TOKEN,
        datadog_rum_app_id: import.meta.env.VITE_DATADOG_RUM_APP_ID,
        datadog_rum_client_token: import.meta.env.VITE_DATADOG_RUM_CLIENT_TOKEN,
    },
    id: import.meta.env.VITE_ID,
    client_id: import.meta.env.VITE_CLIENT_ID,
    aws_client_id: import.meta.env.VITE_AWS_ACCOUNT_ID,
    build_version: import.meta.env.VITE_BUILD_VERSION,
    app_version: import.meta.env.VITE_APP_VERSION,
    serviceName: packageJson.name,
    serviceVersion: packageJson.version,
    serviceEnvironment: import.meta.env.MODE,
    enableMockServer: asBool(import.meta.env.VITE_MOCK_SERVICE),
    logoutUri: import.meta.env.VITE_LOGOUT_URI,
    CHARGING_STATION_WIDGET_ORIGIN: import.meta.env.VITE_CHARGING_STATION_WIDGET_ORIGIN,
};
